import { useDialog } from '@globals/dialog/useDialogStore'
import { Recognition, TenantMemberOrTeamDisplayData } from '@kudos/http-client'
import { Selectable } from '@shared/filters/selections'
import { MOBILE_SEND_RECOGNITION_DRAWER_KEY } from './constants'

export enum MobileRecognitionDrawerView {
  DRAFT_AND_SCHEDULED = 'DraftAndScheduled',
  RECIPIENTS = 'Recipients',
  QUALITIES = 'QualityOptions',
  VISIBILITY = 'Visibility',
  POINTS = 'Points',
  SCHEDULE = 'Schedule',
  POINTS_EXCEPTION = 'PointsException',
}

export type MobileRecognitionDrawerData = {
  view: MobileRecognitionDrawerView
  recognition?: Recognition
  qualities?: Selectable[]
  recipients?: TenantMemberOrTeamDisplayData[]
}

export const MOBILE_RECOGNITION_DRAWER_KEY = 'mobileRecognitionDrawerKey'

const useMobileRecognitionDrawer = () => {
  const {
    setData,
    openDialog: open,
    closeDialog: close,
    isOpen,
    dialogData,
  } = useDialog<MobileRecognitionDrawerData>(MOBILE_RECOGNITION_DRAWER_KEY)
  const { openDialog: openSendDialog } = useDialog(MOBILE_SEND_RECOGNITION_DRAWER_KEY)

  return {
    setView: (
      view: MobileRecognitionDrawerView,
      data?: Partial<Omit<MobileRecognitionDrawerData, 'view'>>,
    ) => {
      setData({ ...(dialogData ?? {}), view, ...data })
    },
    openDrawer: (data?: Partial<MobileRecognitionDrawerData>) => {
      const payload = {
        view: data?.view ?? MobileRecognitionDrawerView.DRAFT_AND_SCHEDULED,
        recognition: data?.recognition,
        qualities: data?.qualities,
        recipients: data?.recipients,
      }
      const hasRecipientsOrQualities =
        (payload.recipients?.length ?? 0) > 0 || (payload.qualities?.length ?? 0) > 0

      if (hasRecipientsOrQualities || !!payload.recognition) {
        setData(payload)
        openSendDialog()
      } else {
        open(payload)
      }
    },
    closeDrawer: () => {
      close()
    },
    isOpen,
    dialogData,
  }
}

export default useMobileRecognitionDrawer
